/**
 * Validation et nettoyage des URLs pour le SEO
 * Empêche les URLs malformées d'être indexées
 */

/**
 * Vérifie si une URL est valide et SEO-friendly
 */
export const isValidSEOUrl = (url: string): boolean => {
  // URLs à exclure complètement
  const excludePatterns = [
    /\{.*?\}/,                    // Placeholders non remplacés comme {search_term_string}
    /[<>"`]/,                     // Caractères dangereux
    /[\u0000-\u001F\u007F-\u009F]/, // Caractères de contrôle
    /\s/,                         // Espaces non encodés
    /%7B|%7D/i,                   // Placeholders encodés
    /\/\/+/,                      // Double slashes (sauf après protocol://)
    /\?.*=undefined/i,            // Paramètres undefined
  ];

  // Vérifier chaque pattern d'exclusion
  for (const pattern of excludePatterns) {
    if (pattern.test(url)) {
      console.warn(`❌ URL invalide (pattern ${pattern}):`, url);
      return false;
    }
  }

  // Vérifier les doubles préfixes de langue
  if (/\/(fr|en|es)\/(fr|en|es)\//.test(url)) {
    console.warn('❌ URL avec double préfixe langue:', url);
    return false;
  }

  return true;
};

/**
 * Nettoie une URL pour la rendre SEO-safe
 */
export const sanitizeSEOUrl = (url: string): string | null => {
  if (!isValidSEOUrl(url)) {
    return null;
  }

  // Nettoyer l'URL
  let clean = url
    .replace(/\/+/g, '/') // Normaliser les slashes
    .replace(/\/$/, '');  // Retirer slash final sauf racine

  return clean || '/';
};

/**
 * Valide un slug de serveur
 */
export const isValidServerSlug = (slug: string): boolean => {
  // Un slug valide : 3-100 caractères, alphanumérique et tirets
  return /^[a-z0-9][a-z0-9-]{1,98}[a-z0-9]$/.test(slug);
};

/**
 * Valide un slug de jeu
 */
export const isValidGameSlug = (slug: string): boolean => {
  // Un slug de jeu valide : 2-80 caractères, alphanumérique et tirets
  return /^[a-z0-9][a-z0-9-]{0,78}[a-z0-9]$/.test(slug);
};

/**
 * Liste des caractères interdits dans les URLs
 */
export const FORBIDDEN_URL_CHARS = [
  '<', '>', '"', '`', '{', '}', '|', '\\', '^', '[', ']', ' '
];

/**
 * Vérifie si une chaîne contient des caractères interdits
 */
export const containsForbiddenChars = (str: string): boolean => {
  return FORBIDDEN_URL_CHARS.some(char => str.includes(char));
};
